export enum LeyendaEmisor {
    Contado,
    CtaCorriente,
    Exportacion,
    ClienteMonotributista,
    ClienteConITC,
    EsAeronafta
}